import { signOut } from 'firebase/auth';
import { getFirebaseAuth } from './firebaseAuth';
import { getPortalConfig } from './portals';

let ending = false;

// Every way a Session can end (a second 401, a dead token, another tab signing
// out) goes through here, so the user is signed out and sent to the Portal's
// login page exactly once, with a full reload to reset app state.
export function endSession(portal) {
  if (ending) {
    return Promise.resolve();
  }
  ending = true;

  const auth = getFirebaseAuth();
  const signedOut =
    auth && auth.currentUser ? signOut(auth) : Promise.resolve();

  return signedOut
    .catch(() => {})
    .then(() => {
      window.location.replace(getPortalConfig(portal).loginPath);
    });
}
